import { styled } from '@mui/system';
import { Box } from '@mui/material';

export const Body = styled(Box)({
	height: '100%',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
});
